export function normalizeYouTubeUrl(input) {
  if (!input || typeof input !== 'string') return null;

  let url;
  try {
    url = new URL(input.includes('://') ? input : `https://${input}`);
  } catch (e) {
    const idOnly = extractIdFromString(input);
    return idOnly ? `https://youtube.com/watch?v=${idOnly}` : null;
  }

  const hostname = url.hostname.replace('www.', '').toLowerCase();
  let id = null;

  if (hostname === 'youtu.be') {
    id = url.pathname.slice(1).split(/[/?#]/)[0];
  }

  if (!id) {
    id = url.searchParams.get('v');
  }

  if (!id) {
    const embedMatch = url.pathname.match(/\/embed\/([A-Za-z0-9_-]{11})/);
    if (embedMatch) id = embedMatch[1];
  }

  if (!id) {
    const vMatch = url.pathname.match(/\/v\/([A-Za-z0-9_-]{11})/);
    if (vMatch) id = vMatch[1];
  }

  if (!id && url.hash) {
    const hash = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash;
    const hashParams = new URLSearchParams(hash.replace(/^!/, '')); // handle #!v=...
    if (hashParams.get('v')) id = hashParams.get('v');
  }

  if (!id) {
    const maybe = extractIdFromString(input);
    if (maybe) id = maybe;
  }

  if (id && /^[A-Za-z0-9_-]{11}$/.test(id)) {
    return `https://youtube.com/watch?v=${id}`;
  }

  return null;
}

function extractIdFromString(s) {
  if (!s || typeof s !== 'string') return null;
  const match = s.match(/([A-Za-z0-9_-]{11})/);
  return match ? match[1] : null;
}

export default normalizeYouTubeUrl
